import React from 'react';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const StatusFilter = ({ selectedStatuses, onChange }) => {
  const { t } = useTranslation();
  
  // Status options with translation keys
  const STATUS_OPTIONS = [
    { value: 'Active', color: 'bg-green-100 text-green-800', translationKey: 'common.status.active' },
    { value: 'Pending', color: 'bg-yellow-100 text-yellow-800', translationKey: 'common.status.pending' },
    { value: 'Completed', color: 'bg-blue-100 text-blue-800', translationKey: 'common.status.completed' },
    { value: 'OnHold', color: 'bg-orange-100 text-orange-800', translationKey: 'common.status.onHold' },
    { value: 'Cancelled', color: 'bg-red-100 text-red-800', translationKey: 'common.status.cancelled' }
  ];

  const toggleStatus = (status) => {
    if (selectedStatuses.includes(status)) {
      onChange(selectedStatuses.filter(s => s !== status));
    } else {
      onChange([...selectedStatuses, status]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {STATUS_OPTIONS.map((status) => (
        <button
          key={status.value}
          onClick={() => toggleStatus(status.value)}
          className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium 
            ${status.color} hover:opacity-80 transition-opacity
            ${selectedStatuses.includes(status.value) ? 'ring-2 ring-offset-2 ring-gray-500' : 'opacity-60'}`}
        >
          <span className="mr-1.5">{t(status.translationKey)}</span>
          {selectedStatuses.includes(status.value) && (
            <Check className="h-4 w-4" />
          )}
        </button>
      ))}
    </div>
  );
};

export default StatusFilter;